import $ from 'jquery';
import 'jquery.cookie';
import 'slick-carousel'

$(document).ready(function () {
  window.dataLayer = window.dataLayer || [];
  window.Shopify = window.Shopify || {};

  const customer = JSON.parse(document.querySelector('[data-shopify-customer]').innerHTML);

  function getAddressData(customer) {
    if (customer.loggedIn) {
      return {
        fullName: customer.name,
        firstName: customer.name.split(' ')[0],
        lastName: customer.name.split(' ')[1],
        address1: '',
        address2: '',
        street: '',
        city: '',
        state: '',
        state_code: '',
        zip: '',
        country: '',
        country_code: '',
        phone: customer.phone,
      };
    } else {
      return {
        fullName: null,
        firstName: null,
        lastName: null,
        address1: null,
        address2: null,
        street: null,
        city: null,
        state: null,
        state_code: null,
        zip: null,
        country: null,
        country_code: null,
        phone: null,
      };
    }
  }

  var defaultAddress = getAddressData(customer);
  var billingInfo = getAddressData(customer);
  window.dataLayer.push({
    event: 'logState',
    logState: customer.loggedIn ? 'Logged In' : 'Logged Out',
    currency: customer.currency,
    customerEmail: customer.email,
    checkoutEmail: customer.email,
    customerInfo: defaultAddress,
    billingInfo: billingInfo,
    shippingInfo: customer.loggedIn
      ? {
          fullName: customer.firstName + ' ' + customer.lastName,
          firstName: customer.firstName,
          lastName: customer.lastName,
          address1: '',
          address2: '',
          street: '',
          city: customer.city,
          state: customer.state,
          state_code: '',
          zip: '',
          country: customer.country,
          country_code: '',
          phone: customer.phone,
        }
      : {
          fullName: null,
          firstName: null,
          lastName: null,
          address1: null,
          address2: null,
          street: null,
          city: null,
          state: null,
          state_code: null,
          zip: null,
          country: null,
          country_code: null,
          phone: null,
        },
  });

  setTimeout(function () {
    window.dataLayer.push({
      event: 'page_view',
      page_type: customer.page_type,
      shop_id: 'bws',
      page_title: document.title,
      page_location: window.location.href,
    });
  }, 200);

  /* Mattress features-section slider 04-11-2020 */
  $('.features-section .features-listing').slick({
    arrows: true,
    autoplay: false,
    draggable: true,
    speed: 300,
    loop: true,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    centerMode: true,
    centerPadding: '175px',
    slidesToShow: 3,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          centerPadding: '175px',
          slidesToShow: 1,
          centerMode: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerPadding: '50px',
          slidesToShow: 1,
          centerMode: true,
        },
      },
    ],
  });
});

// Promo slider slick on mobile
var $slick_slider = $('.promo-slick-slider');
var settings_slider = {
  autoplay: true,
  autoplaySpeed: 3500,
  dots: false,
  arrows: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

slick_on_mobile($slick_slider, settings_slider);

// Mattress category slider
var $m_slick_slider = $('.mattress-slider');
var m_settings_slider = {
  dots: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  draggable: true,
  swipe: true,
  touchMove: true,
  responsive: [
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 3.7,
        slidesToScroll: 1,
        draggable: true,
        swipe: true,
        touchMove: true,
      },
    },
    {
      breakpoint: 1680,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        draggable: true,
        swipe: true,
        touchMove: true,
      },
    },
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 3.2,
        slidesToScroll: 1,
        draggable: true,
        swipe: true,
        touchMove: true,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        draggable: true,
        swipe: true,
        touchMove: true,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        draggable: true,
        swipe: true,
        touchMove: true,
        centerMode: true,
        centerPadding: '120px',
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        draggable: true,
        swipe: true,
        touchMove: true,
        centerPadding: '175px',
        centerMode: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        draggable: true,
        swipe: true,
        touchMove: true,
        centerPadding: '50px',
        centerMode: true,
      },
    },
  ],
};

mattress_slick_on_mobile($m_slick_slider, m_settings_slider);

function slick_on_mobile(slider, settings) {
  var screen_size = 1024;
  $(window).on('load resize', function () {
    if ($(window).width() > screen_size) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      return;
    }
    if (!slider.hasClass('slick-initialized')) {
      return slider.slick(settings);
    }
  });
}

function mattress_slick_on_mobile(slider, settings) {
  var screen_size = 300;
  $(window).on('load resize', function () {
    if ($(window).width() < screen_size) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      return;
    }
    if (!slider.hasClass('slick-initialized')) {
      return slider.slick(settings);
    }
  });
}

function megamenu_link() {
  $('.inner-submenu-listing .has-subMenu').click(function (event) {
    if ($(window).width() <= 1080) {
      event.preventDefault();
    }
  });
}

/* New Header CHanges*/
/*equalHeight*/
function eqHeight() {
  jQuery.fn.extend({
    equalHeights: function () {
      var top = 0;
      var row = [];
      var classname = ('equalHeights' + Math.random()).replace('.', '');
      $(this)
        .each(function () {
          var thistop = $(this).offset().top;
          if (thistop > top) {
            $('.' + classname).removeClass(classname);
            top = thistop;
          }
          $(this).addClass(classname);
          $(this).height('auto');
          var h = Math.max.apply(
            null,
            $('.' + classname)
              .map(function () {
                return $(this).height();
              })
              .get()
          );
          $('.' + classname).height(h);
        })
        .removeClass(classname);
    },
  });
  jQuery('.fabric-listing li p').equalHeights();
  jQuery('.award-page-listing .promise-img').equalHeights();
  jQuery('.customer-care-listing li i').equalHeights();
  jQuery('.features-listing .inner-features-listing').equalHeights();
  jQuery('.night-sleep-listing li h2').equalHeights();
  jQuery('.night-sleep-listing li .night-sleep-img').equalHeights();
  jQuery('.category-page .mattress-detail-outer .inner-mattress-detail h3,.category-page .mattress-detail-outer .inner-mattress-detail .title-wrap').equalHeights();

  jQuery('.ratting-section .text-trust-section .slick-track .bundle-text').equalHeights();
  jQuery('.ratting-section .text-trust-section .slick-track .bundle-text .ratting-description').equalHeights();
  jQuery('.ratting-section .text-trust-section .slick-track .bundle-text .section-title').equalHeights();

  jQuery(".mattress-product .mattress-product-content .product-title").equalHeights();
  jQuery(".mattress-product .mattress-price-list").equalHeights();
  jQuery(".mattress-product .section-promise ul li .promise-img").equalHeights();
  jQuery(".mattress-product .section-promise ul li p").equalHeights();
  jQuery(".mattress-product .mattress-img .img-wrap").equalHeights();

  if ($(window).width() > 767) {
    $(
      '.plant-trees .section-one-for-everyone.sustainability-everyone p'
    ).equalHeights();
    $(
      '.plant-trees .section-one-for-everyone.sustainability-everyone li'
    ).equalHeights();
  }
}

function featuresBlockeqHeight() {
  $('.mettress-block .features-block-outer').css('height', 'auto');
  var HeightArray = 0;
  var i = 0;
  var max = 0;
  $('.mettress-block .features-block-outer').each(function () {
    HeightArray = $(this).height();
    max = Math.max(max, HeightArray);
  });
  $('.mettress-block .features-block-outer').each(function () {
    $(this).height(max);
  });
}

//custom color text start

$('.navUser-item.navUser-item--cart').click(function () {
  setTimeout(function () {
    $('.previewCart .previewCartList .previewCartItem').each(function () {
      var miniCartTitle = $(this)
        .find('.previewCartItem-content .previewCartItem-name a')
        .text()
        .replace(/\s+/g, ' ')
        .trim();
      if (miniCartTitle == 'Test Product') {
        $(this)
          .find(
            '.previewCartItem-content .definitionList .definitionList-value'
          )
          .each(function () {
            var optionValue = $(this).text().replace(/\s+/g, ' ').trim();
            if (optionValue == 'Custom') {
              $(this).css('display', 'none');
            }
          });
      }
    });
  }, 1500);
});
//custom color text end

//  klarna purchaseAmount code
document.addEventListener('DOMContentLoaded', function () {
  if ($('.productView-options .checkprice').length > 0) {
    var priceRange = $('.productView-options .checkprice')
      .text()
      .split('-');
  } else {
    var priceRange = $('.productView-options .price--withTax')
      .text()
      .split('-');
  }
  var productPriceText = priceRange[0].replace('£', '').replace(',', '');
  if (productPriceText) {
    var productPrice = Math.round(parseFloat(productPriceText) * 100);
    var klarnaPlacement = document.querySelector('klarna-placement');
    if (klarnaPlacement) {
      klarnaPlacement.dataset.purchaseAmount = productPrice.toString();
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }
  }
});

// dynamic finance rate
function dynamicFinanceRate() {
  setTimeout(function () {
    if (
      $('#calc-table-data tr:last td').attr(
        'data-imega-calculator-field'
      ) == 'apr'
    ) {
      var apr = $('#calc-table-data tr:last td').text();
      $('#imega-widget-anchor .imega-slug strong').after(function () {
        $(this.nextSibling).remove();
        return '/month with ' + apr + ' interest';
      });
    }
  }, 1000);
}

function setCopyrightDate() {
  var copydate = $('.footer_copyright_date').text();
  var dt = new Date(copydate);
  $('.footer_copyright_date').text(dt.getFullYear());
}

// newsletter js start
function IsEmail(email) {
  var regex =
    /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (!regex.test(email)) {
    return false;
  } else {
    return true;
  }
}
$('.form-prefixPostfix-button--postfix').click(function () {
  var n1Email = $('#nl_email').val();
  if (n1Email != '' && IsEmail(n1Email)) {
    $('.form-inlineMessage.nl-email-error.desktop').removeClass(
      'n1-error-label'
    );
    $('.form-inlineMessage.nl-email-error.mobile').removeClass(
      'n1-error-label'
    );
    var jsonObjects = {
      email: n1Email,
      acceptsMarketingNewsletter: true,
      acceptsAbandonedCartEmails: true,
    };
    jQuery
      .ajax({
        type: 'POST',
        url: 'https://brookandwildesleep.com/api/storefront/subscriptions',
        data: JSON.stringify(jsonObjects),
        dataType: 'json',
        encode: true,
      })
      .done(function (data) {
        $('.offer.n1-page-load').attr('style', 'display:none');
        if (data.dateCreated === data.dateModified) {
          $('.offer.n1-thank-you').attr('style', 'display:block');
          //  $('#newsletter-subscription-form .form-prefixPostfix.wrap').attr('style','display:none');
          $('#newsletter-subscription-form').attr('style', 'display:none');
        } else {
          $('.offer.n1-subscribed').attr('style', 'display:block');
          // $('#newsletter-subscription-form .form-prefixPostfix.wrap').attr('style','display:none');
          $('#newsletter-subscription-form').attr('style', 'display:none');
        }
      });
    event.preventDefault();
  } else {
    $('.form-inlineMessage.nl-email-error.desktop').addClass(
      'n1-error-label'
    );
    $('.form-inlineMessage.nl-email-error.mobile').addClass(
      'n1-error-label'
    );
  }
});
// newsletter js end

/* Option-level stock issue on 25-10-2023 starts */
function removeDisableOptionLevelStock() {
  if (
    $(
      '.product-detail-page .productView .productView-details .productView-options .form .form-field .test-option'
    ).length > 0
  ) {
    $(
      '.product-detail-page .productView .productView-details .productView-options .form .form-field .test-option'
    ).removeAttr('disabled');
  }
}
/* Option-level stock issue on 25-10-2023 ends */

//home banner mobile animation start
function bannerMobileAnimation() {
  var blockHeight = $('.home-banner-caption').outerHeight() + 65;
  var winht = $(window).height(),
    navht = $('.header').innerHeight(),
    triggerH = navht / winht;
  $('.spacer').css('top', navht);
  var totalHeight = blockHeight + navht;

  var controller = new ScrollMagic.Controller({
    container: window,
  });

  if ($(window).width() < 581) {
    var scene = new ScrollMagic.Scene({
      triggerElement:
        $(window).width() < 581 ? '#home-banner-trigger' : '',
      offset: 0,
      triggerHook: triggerH,
      duration: totalHeight,
      reverse: true,
    })
      .setPin('.home-banner-wrapper')
      .setClassToggle('#home-banner-trigger', 'enter')
      .addTo(controller);
  }
}
//home banner mobile animation end

/*brunel-modal*/
function brunel_modal() {
  $('#brunel-modal').click(function () {
    eqHeight();
    $('body,html').addClass('open-brunel-modal');
    $('#overlay').css('display', 'block');
    $('#brunel-sofa-modal').css('display', 'block');
  });
  $('#overlay,.modal-brunel .cancel,.modal-brunel,.popup-close-link').click(
    function () {
      $('body,html').removeClass('open-brunel-modal');
      $('#overlay').fadeOut();
      $('#brunel-sofa-modal').fadeOut();
    }
  );
  $('.modal-brunel-inner').click(function (event) {
    event.stopPropagation();
  });
}
/*end*/

/* brunel-tab */
function brunel_tab() {
  $('.brunel-tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');
    $('.brunel-tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $('#' + tab_id).addClass('current');
  });
}
/*end*/

/* video*/
function isOnScreen(elem) {
  if (elem.length == 0) {
    return;
  }
  var $window = $(window);
  var viewport_top = $window.scrollTop();
  var viewport_height = $window.height();
  var viewport_bottom = viewport_top + viewport_height;
  var $elem = $(elem);
  var top = $elem.offset().top;
  var height = $elem.height();
  var bottom = top + height;

  return (
    (top >= viewport_top && top < viewport_bottom) ||
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    (height > viewport_height &&
      top <= viewport_top &&
      bottom >= viewport_bottom)
  );
}

function reviewSlider() {
  /* ratting section slider 15-9-2023 */
  $('.ratting-section-slider').slick({
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  });
  /*end */
}

/* PDP Discount price js as per promo start 29-01-2024 */

// Function to calculate 60% discount for PDP
function calculateDiscount(price, discPrice) {
  if (isNaN(price)) {
    return 'Invalid input. Please provide a valid number.';
  }

  // Calculate the discounted price
  const discountPercentage = discPrice;
  const discountAmount = (discountPercentage / 100) * price;
  const discountedPrice = price - discountAmount;

  return discountedPrice;
}

function PromoPDPPrice(priceRange) {
  var originalPrice = priceRange;

  var discount50 = 50;
  var discount55 = 55;
  var discount45 = 45;
  var discount40 = 40;
  var discount30 = 30;
  var discount20 = 20;
  var discount25 = 25;
  var discount35 = 35;
  var discount33 = 33;

  if (originalPrice) {
    const discountedPrice50 = calculateDiscount(originalPrice, discount50);
    const discountedPrice55 = calculateDiscount(originalPrice, discount55);
    const discountedPrice45 = calculateDiscount(originalPrice, discount45);
    const discountedPrice40 = calculateDiscount(originalPrice, discount40);
    const discountedPrice30 = calculateDiscount(originalPrice, discount30);
    const discountedPrice20 = calculateDiscount(originalPrice, discount20);
    const discountedPrice25 = calculateDiscount(originalPrice, discount25);
    const discountedPrice35 = calculateDiscount(originalPrice, discount35);
    const discountedPrice33 = calculateDiscount(originalPrice, discount33);

    $('#discounted-price-pdp-50').text(discountedPrice50.toFixed(2));
    $('#discounted-price-pdp-55').text(discountedPrice55.toFixed(2));
    $('#discounted-price-pdp-45').text(discountedPrice45.toFixed(2));
    $('#discounted-price-pdp-40').text(discountedPrice40.toFixed(2));
    $('#discounted-price-pdp-30').text(discountedPrice30.toFixed(2));
    $('#discounted-price-pdp-20').text(discountedPrice20.toFixed(2));
    $('#category-product-discount-price').text(discountedPrice20.toFixed(2));
    $('#discounted-price-pdp-25').text(discountedPrice25.toFixed(2));
    $('#discounted-price-pdp-35').text(discountedPrice35.toFixed(2));
    $('#discounted-price-pdp-33').text(discountedPrice33.toFixed(2));
  } else {
    $('#discounted-price-pdp-50').text('Error');
    $('#discounted-price-pdp-55').text('Error');
    $('#discounted-price-pdp-45').text('Error');
    $('#discounted-price-pdp-40').text('Error');
    $('#discounted-price-pdp-30').text('Error');
    $('#discounted-price-pdp-20').text('Error');
    $('#category-product-discount-price').text('Error');
    $('#discounted-price-pdp-25').text('Error');
    $('#discounted-price-pdp-35').text('Error');
    $('#discounted-price-pdp-33').text('Error');
  }
}
/* PDP Discount price js as per promo ends */

function showTooltipBundle() {
  $('.category-discount-code-button1').addClass('discount-notify1');
  var buttonText = $('#code-text1').text();
  navigator.clipboard.writeText(buttonText);

  setTimeout(function () {
    $('.category-discount-code-button1').removeClass('discount-notify1');
  }, 2000);
}

function showTooltip55() {
  $('.category-discount-code-button2').addClass('discount-notify2');
  var buttonText = $('#code-text2').text();
  navigator.clipboard.writeText(buttonText);

  setTimeout(function () {
    $('.category-discount-code-button2').removeClass('discount-notify2');
  }, 2000);
}

function ManageCookiePreference() {
  event.stopPropagation();
  window.consentManager.openConsentManager();
  $(
    '.css-10z1g2q .css-a0j149 span,#consent-manager .css-ra9y5f a,#consent-manager .css-ra9y5f span'
  ).css('display', 'none');
  $('#consent-manager .css-ra9y5f .css-bhz559 span').css(
    'display',
    'block'
  );
}

$(document).ready(function () {
  setTimeout(function () {
    reviewSlider();
  }, 100);
  setCopyrightDate();
  //bannerMobileAnimation();

  /* orange strip 4-9-2023 */
  var header_H = $('.header').outerHeight();
  var modal_promo = $('.modal-promo').outerHeight();
  setTimeout(function () {
    $('.modal-promo').css('top', header_H);
    $('.body').css('margin-top', header_H + modal_promo);
    $('.homepage .body').css('margin-top', header_H);
  }, 500);
  /*end*/

  $('#consent-manager').css('display', 'block');

  // custom cookie js start
  if (typeof jQuery.cookie('tracking-prefernces') === 'undefined') {
    $('.press-logo-section').addClass('for-cookie-adjust');
    //no cookie
  }
  $('#consent-manager .css-a0j149').first().remove();
  $('#consent-manager .css-10z1g2q div')
    .first()
    .css('justify-content', 'center');
  $('.css-a0j149').html('');
  $('.css-a0j149').append('<span>ACCEPT + CONTINUE</span>');
  $('#consent-manager .css-bhz559 span').text(
    'We use cookies to improve user experience, understand traffic, and manage advertising.'
  );
  //$('#consent-manager .css-ra9y5f').append('<a href="https://brookandwildesleep.com/cookies/" target="_blank">Read here for more.</a>');
  $('#consent-manager .css-ra9y5f').append(
    '<a href="https://brookandwildesleep.com/cookies/" target="_blank">Read here</a> <span>for more or </span><a onclick="ManageCookiePreference()">manage your preferences.</a>'
  );

  // end

  $('.img-block-wrapper .video-block .perla-video').trigger('pause');
  $(window).scroll(function () {
    if (isOnScreen($('.img-block-wrapper .video-block'))) {
      $('.img-block-wrapper .video-block .perla-video').trigger('play');
    } else {
      $('.img-block-wrapper .video-block .perla-video').trigger('pause');
    }
  });
});

$(window).resize(function () {
  /*if($('.home-slider > .inner-div').length > 0){
        $('.home-slider > .inner-div')[0].slick.refresh();
        $(".home-slider > .inner-div").slick({
          dots: true,
          infinite: true,
          slidesToShow: 1,
          loop:true,
          autoplaySpeed:7000,
          autoplay: true,
          pauseOnHover:true,
          slidesToScroll: 1
        });
    } */

  /* orange strip 4-9-2023 */

  var header_H = $('.header').outerHeight();
  var modal_promo = $('.modal-promo').outerHeight();
  setTimeout(function () {
    $('.modal-promo').css('top', header_H);
    $('.body').css('margin-top', header_H + modal_promo);
    $('.homepage .body').css('margin-top', header_H);
  }, 500);

  /*end*/
});

$(document).ready(function () {
  /* mattress-cateogry-new desing pagejd  start 23-11-2020 */
  if ($('.best-mattress').length) {
    $('.best-mattress li a').click(function () {
      $('.best-mattress li a').not($(this)).removeClass('active');
      $(this).addClass('active');
      var idFlag = false;
      var activeBtnId = $(this).data('src');
      $(this)
        .closest('.features-section')
        .find('.listing-wrapper')
        .each(function () {
          var activeSlideId = $(this).data('src');
          if (activeSlideId == activeBtnId) {
            if (!idFlag) {
              var activeSlideIndex = $(this).parent().parent('.slick-slide').data('slickIndex');
              if (activeSlideIndex >= 0) {
                idFlag = true;
                $(this).closest('.features-listing').slick('slickGoTo', activeSlideIndex);
              }
            }
          }
        });
    });
  }
  /* category-page js for listing 08-12-2020 */
  if ($('.night-sleep-listing>li').length == 1) {
    $('.category-page .category-page-detail .night-sleep-listing').addClass(
      'single-item'
    );
  }

  if ($('.night-sleep-listing>li').length == 2) {
    $('.category-page .category-page-detail').addClass('two-col-listing');
  }

  if ($('.features-listing')) {
    $('.features-listing').on('afterChange', function () {
      var activeSlideId = $('.features-listing .slick-current .listing-wrapper').data('src');
      $('.best-mattress li a').removeClass('active');
      $('.best-mattress li a').each(function () {
        var activeBtnId = $(this).data('src');
        if (activeBtnId == activeSlideId) {
          $(this).addClass('active');
        }
      });
    });
  }
  /* mattress-cateogry-new desing pagejd  end */

  // Hide thumbnails if there is 1 image
  if ($(window).width() > 1080) {
    if ($('.productView-thumbnail').length == 1) {
      $('.productView-thumbnails').hide();
    } else {
      $('.productView-thumbnails').show();
    }
  }
  // Hide thumbnails if there is 1 image

  /* home-slider */
  /*$(".home-slider > .inner-div").slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        loop:true,
        pauseOnHover:true,
        autoplaySpeed:7000,
        autoplay: true,
        slidesToScroll: 1
    });*/

  //var lastScrollTop = 0
  var lastScrollTop = $('header').height();

  $(window).scroll(function (event) {
    /*desktop-header-js*/
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
      $('.header, body').addClass('fixed-header');
    } else {
      $('.header, body').removeClass('fixed-header');
    }
  });
});

/*mobile-mega-menu-js-start*/
$('.navPages-action.has-subMenu').click(function () {
  $('.submenu-listing-wrapper')
    .not($(this).closest('.navPages-item').find('.submenu-listing-wrapper'))
    .removeClass('submenu-open');
  $(this).toggleClass('is-open');
  $(this)
    .closest('.navPages-item')
    .find('.submenu-listing-wrapper')
    .toggleClass('submenu-open');
});

$('.inner-submenu-listing .has-subMenu ').click(function () {
  $('.inner-submenu-listing .has-subMenu .navPages-action-moreIcon')
    .not($(this).parent('.has-subMenu'))
    .removeClass('is-open');
  $(this).toggleClass('is-open');
  $('.inner-submenu-listing .inner-submenu')
    .not($(this).siblings('.navPage-subMenu').find('.inner-submenu'))
    .removeClass('submenu-open');
  $(this)
    .siblings('.navPage-subMenu')
    .find('.inner-submenu')
    .toggleClass('submenu-open');
});
/*mobile-mega-menu-js-end*/

/*Code for making href remove from mobile view */
if ($(window).width() <= 1080) {
  $('ul.navPages-list li a.has-subMenu').click(function (e) {
    return false;
  });
}
/*Code for making href remove from mobile view */

/* mobile menu new js start 08-07-2020*/
$('header .header-inner .navPages-action').removeClass('is-open');
$('header .header-inner ul li a.navPages-action').click(function () {
  $('header .header-inner .navPages-action').not($(this)).removeClass('open');
  $(this).toggleClass('open');
  $(this)
    .siblings()
    .find('li.inner-submenu-listing .has-subMenu')
    .removeClass('open');
  $(this)
    .siblings()
    .find('li.inner-submenu-listing .has-subMenu')
    .siblings()
    .find('.inner-submenu')
    .removeClass('submenu-open');
  $('header .header-inner ul .Clearance a.navPages-action').removeClass('open');
});
$('header .submenu-listing li.inner-submenu-listing .has-subMenu').removeClass(
  'is-open'
);
$('header .submenu-listing li.inner-submenu-listing .has-subMenu').click(
  function () {
    $('header .submenu-listing li.inner-submenu-listing .has-subMenu')
      .not($(this))
      .removeClass('open');
    $(this).toggleClass('open');
  }
);
/* mobile menu new js end*/

// For active-menu
var pageURL = [
  '/mattresses/',
  '/the-lux-mattress/',
  '/the-elite-mattress/',
  '/beds-frame/',
  '/brook-wilde-ottoman-bed/',
  '/brook-wilde-divan-bed/',
  '/duchess-bed/',
  '/rugs/',
  '/alexia-antique-navy-rug/',
  '/alexia-antique-orange-rug/',
  '/alexia-silver-rug/',
  '/alexia-medallion-ivory-rug/',
  '/ascot-beige-rug/',
  '/ascot-silver-rug/',
  '/ascot-silver-pink-rug/',
  '/ascot-silver-yellow-rug/',
  '/oriel-charcoal-rug/',
  '/oriel-silver-rug/',
  '/oriel-blue-rug/',
  '/oriel-ivory-rug/',
  '/darwin-charcoal-rug/',
  '/darwin-silver-rug/',
  '/darwin-teal-rug/',
  '/savoy-beige-rug/',
  '/savoy-mustard-rug/',
  '/savoy-teal-rug/',
  '/savoy-charcoal-rug/',
  '/wolfson-charcoal-rug/',
  '/wolfson-cream-rug/',
  '/wolfson-pink-rug/',
  '/wolfson-mustard-rug/',
  '/rugs-trinity-copper',
  '/rugs-trinity-mustard',
  '/rugs-trinity-pink',
  '/rugs-trinity-teal',
  '/rugs-hallward-emerald',
  '/rugs-hallward-pearl',
  '/rugs-hallward-taupe',
  '/rugs-hallward-silver',
  '/blanket-boxes/',
  '/florence-blanket-box/',
  '/verona-blanket-box/',
  '/bed-linen/',
  '/draper-london-hero-bed-linen-set-aquamarine',
  '/draper-london-hero-bed-linen-set-navy',
  '/draper-london-hero-bed-linen-set-silver',
  '/bedding/duvets/',
  '/everdene-duvet/',
  '/cavendish-duvet/',
  '/marlowe-duvet/',
  '/eco-duvet/',
  '/bedding/pillows/',
  '/everdene-pillow/',
  '/cavendish-pillow/',
  '/marlowe-pillow/',
  '/fbc-dual-support-memory-foam-pillow/',
  '/bedding/protectors/',
  '/breathe-mattress-protector/',
  '/spundown-pillow-protector/',
  '/accessories/bundles/',
  '/accessories/bundles/lux-ottoman-bundle/',
  '/mattress-pillow-bundle/',
  '/bedding-collection/',
  '/accessories/bundles/lux-ottoman-bundle/',
  '/accessories/bundles/elite-ottoman-bundle',
  '/accessories/bundles/lux-divan-bundle-single',
  '/accessories/bundles/lux-divan-bundle-double',
  '/accessories/bundles/lux-divan-bundle-king',
  '/accessories/bundles/lux-divan-bundle-super-king',
  '/accessories/bundles/elite-divan-bundle-single',
  '/accessories/bundles/elite-divan-bundle-double',
  '/elite-divan-bundle-king/',
  '/elite-divan-bundle-super-king/',
  '/rugs/hallwood/hallward-dusk-rug/',
  '/rugs/hallwood/hallward-ocean-rug/',
  '/rugs-hallward-sand',
  '/rugs/hallwood/hallward-taupe-rug/',
  '/rugs/hallwood/hallward-zinc-rug/',
  '/rugs/avondale/avondale-caramel-rug/',
  '/rugs-avondale-cream',
  '/rugs/avondale/avondale-grey-rug/',
  '/rugs/avondale/avondale-mustard-rug/',
  '/rugs/avondale/avondale-navy-rug/',
  '/rugs/avondale/avondale-silver-rug/',
  '/rugs/avondale/avondale-taupe-rug/',
  '/darwin-putty-rug/',
  '/bedding/bed-linen-sets/',
  '/accessories/bundles/lux-ottoman-bundle',
  '/draper-hero-bed-linen-set-acquamarine',
  '/draper-hero-bed-linen-set-navy',
  '/draper-hero-bed-linen-set-silver',
  /* "/the-wessex-chair/",
  "/the-woodbridge-chair/",
  "/the-beaumont-chair/",*/
  /*"/chairs/",*/
  '/the-brunel-sofa-bed/',
  '/the-ultima-mattress/',
  '/the-aubrey-bed-frame/',
  '/the-duke-bed-frame/',
  '/duchess-bed/',
  '/the-verity-bed-frame/',
  '/brook-wilde-ottoman-bed/',
  '/brook-wilde-divan-bed/',
  '/bed-frames/',
  '/the-kensington-mattress-protector/',
  '/bed-linen/',
  '/accessories/',
  '/bedrooms/',
  '/the-warwick-bedside-cabinet/',
  '/the-stirling-bedside-cabinet/',
  '/the-warwick-6-drawer-chest/',
  '/the-warwick-double-wardrobe/',
  '/the-stirling-4-drawer-chest/',
  '/the-warwick-triple-wardrobe/',
  '/the-stirling-double-wardrobe/',
  '/the-perla-mattress/',
  '/sofas-chairs/',
  '/the-beaumont-chair/',
  '/the-wessex-chair/',
  '/the-woodbridge-chair/',
  '/the-byron-sofa/',
  '/the-brunel-sofa/',
  '/the-amis-sofa/',
  '/the-milne-sofa/',
  '/the-churchill-sofa/',
  '/the-fenton-sofa/',
  '/sofa-beds/',
  '/the-byron-sofa-bed/',
  '/the-brunel-sofa-bed/',
  '/the-amis-sofa-bed/',
  '/the-milne-sofa-bed/',
  '/the-churchill-sofa-bed/',
  '/the-fenton-sofa-bed/',
  '/cushions-throws/',
  '/balmoral-cushion/',
  '/the-balmoral-throw/',
  '/bundles/',
  '/everdene-duvet-pillow-bundle/',
];

var menuURL = [
  'https://brookandwildesleep.com/mattresses/',
  'https://brookandwildesleep.com/mattresses/',
  'https://brookandwildesleep.com/mattresses/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/blanket-boxes/',
  'https://brookandwildesleep.com/blanket-boxes/',
  'https://brookandwildesleep.com/blanket-boxes/',
  'https://brookandwildesleep.com/bed-linen/',
  'https://brookandwildesleep.com/bed-linen/',
  'https://brookandwildesleep.com/bed-linen/',
  'https://brookandwildesleep.com/bed-linen/',
  'https://brookandwildesleep.com/bedding/duvets/',
  'https://brookandwildesleep.com/bedding/duvets/',
  'https://brookandwildesleep.com/bedding/duvets/',
  'https://brookandwildesleep.com/bedding/duvets/',
  'https://brookandwildesleep.com/bedding/duvets/',
  'https://brookandwildesleep.com/bedding/pillows/',
  'https://brookandwildesleep.com/bedding/pillows/',
  'https://brookandwildesleep.com/bedding/pillows/',
  'https://brookandwildesleep.com/bedding/pillows/',
  'https://brookandwildesleep.com/bedding/pillows/',
  'https://brookandwildesleep.com/bedding/protectors/',
  'https://brookandwildesleep.com/bedding/protectors/',
  'https://brookandwildesleep.com/bedding/protectors/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/rugs/',
  'https://brookandwildesleep.com/bedding/bed-linen-sets/',
  'https://brookandwildesleep.com/accessories/bundles/',
  'https://brookandwildesleep.com/bedding/bed-linen-sets/',
  'https://brookandwildesleep.com/bedding/bed-linen-sets/',
  'https://brookandwildesleep.com/bedding/bed-linen-sets/',
  /*"https://brookandwildesleep.com/chairs/",
  "https://brookandwildesleep.com/chairs/",
  "https://brookandwildesleep.com/chairs/",
  "https://brookandwildesleep.com/chairs/",*/
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/mattresses/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bed-frames/',
  'https://brookandwildesleep.com/bedding/protectors/',
  'https://brookandwildesleep.com/bed-linen/',
  'https://brookandwildesleep.com/accessories/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/bedrooms/',
  'https://brookandwildesleep.com/mattresses/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofas-chairs/',
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/sofa-beds/',
  'https://brookandwildesleep.com/cushions-throws/',
  'https://brookandwildesleep.com/cushions-throws/',
  'https://brookandwildesleep.com/cushions-throws/',
  'https://brookandwildesleep.com/bundles/',
  'https://brookandwildesleep.com/bundles/',
];

if (jQuery.inArray(document.location.pathname, pageURL) != -1) {
  var getIndex = pageURL.indexOf(document.location.pathname);
  var getMenuURL = menuURL[getIndex];
  $('.navPages ul li').each(function () {
    if ($(this).children('a').attr('href') == getMenuURL) {
      $(this).children('a').addClass('active-menu');
    }
  });
}
// For active-menu

$('.inner-submenu-outer .inner-submenu-detail:first-of-type').addClass(
  'active'
);
$('.inner-submenu li').hover(function () {
  var listing = $(this).attr('data-tab');
  $(this)
    .closest('.inner-submenu-listing')
    .find('.inner-submenu-outer .inner-submenu-detail')
    .removeClass('active');
  $(this)
    .closest('.inner-submenu-listing')
    .find('.inner-submenu-outer .inner-submenu-detail')
    .each(function () {
      var listing_detail = $(this).attr('data-link');
      if (listing == listing_detail) {
        $(this).addClass('active');
      }
    });
});

/*header-page-redirect js start 31-01-2020*/
$('.header .header-inner .header-left-menu nav > ul > li > a').click(
  function () {
    if ($(window).width() > 1080) {
      var get_href = $(this).attr('href');
      window.location.href = get_href;
    }
  }
);

$(document).ready(function () {
  $('.blog-detail-summary p').html(
    '<q>' + $('.section-title-detail').text().substr(0, 175) + '...' + '</q>'
  );
  if ($('.hide-menu').length > 0) {
    $('.hide-menu').hide();
  }
  /***Footer accordian**/
  $('.footer-info-list .has-subMenu').click(function () {
    $(this).children('i').toggleClass('is-open');
    $(this).next('.navPage-childList').slideToggle();
  });

  $(
    '.header .header-inner .header-left-menu nav .navPage-subMenu .navPage-subMenu-list .pilow-submenu-wrapper .pillow-desc-listing'
  ).hide();
  if ($(window).width() > 1080) {
    $(
      'header .header-inner .header-left-menu nav .navPage-subMenu .navPage-subMenu-list .pilow-submenu-wrapper .pillo-menu-content-wrapper > ul > li > a'
    ).hover(function () {
      $this = $(this);
      $(this)
        .closest('li')
        .siblings()
        .not($(this).closest('li'))
        .removeClass('active');
      $(
        '.header .header-inner .header-left-menu nav .navPage-subMenu .navPage-subMenu-list .pilow-submenu-wrapper .pillow-desc-listing'
      ).hide();
      $(
        '.header .header-inner .header-left-menu nav .navPage-subMenu .navPage-subMenu-list .pilow-submenu-wrapper .pillow-desc-listing'
      ).each(function () {
        if ($this.closest('li').attr('data-link') == $(this).attr('data-id')) {
          $(this).show();
          $this.closest('li').addClass('active');
        }
      });
    });
  }

  //Product NAme
  $('.cart-item').each(function () {
    if (
      $(this).find('.cart-item-info .cart-item-value:eq(0)').text() == '£0.00'
    ) {
      $(this)
        .find('.cart-item-block .definitionList-key')
        .each(function () {
          var text = $(this).html();
          text = text.replace('Select Your Size', '<span>Size</span>');
          $(this).html(text);
        });
    }
  });

  $(' .help-left-link a[href*="#"]').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate(
      {
        scrollTop:
          $($(this).attr('href')).offset().top -
          $('.header').innerHeight() -
          20,
      },
      500
    );
  });

  $('.navPage-childList-item').each(function () {
    $(this).hover(
      function () {
        var imageName = $(this)
          .find('.megemenu-inner-images img')
          .attr('src');
        $(this)
          .closest('.navPages-item')
          .find('.megemenu-image-img:last')
          .attr('src', imageName);
      },
      function () {}
    );
  });

  // For Pillow Menu
  $('.pillowMenuName').each(function () {
    $(this).hover(
      function () {
        var imageName = $(this)
          .next('.megemenu-inner-images')
          .find('img')
          .attr('src');
        $(this)
          .closest('.navPages-item')
          .find('.megemenu-image-img:last')
          .attr('src', imageName);
      },
      function () {}
    );
  });
  // For Pillow Menu

  /*--accordian--*/
  $('.accrodian-dtl').hide();
  $('.accrodian-head').click(function () {
    var $this = $(this);
    var $parent = $this.parent();
    var $sibling = $this.next();

    $('.accrodian-head').removeClass('active');
    $parent.toggleClass('active');
    $sibling.slideToggle(400);
  });

  /*-- dimension secion description hide/show on 18-09-2023 --*/
  $('.meta-detail-dtl').hide();
  $('.meta-detail-head').click(function () {
    var $this = $(this);
    var $parent = $this.parent();
    var $sibling = $this.next();

    $('.meta-detail-head').removeClass('active');
    $parent.toggleClass('active');
    $sibling.slideToggle(400);
  });

  /*--mattress page OutInTheWilde slider--*/
  $('.out-wilde-slider').slick({
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /*************strip**************************/
  $('a#promo-open > div:first-child').addClass('active');
  setInterval(function () {
    var active = $('a#promo-open > div.active').removeClass('active');
    if (active.next() && active.next().length) {
      active.next().addClass('active');
    } else {
      active.siblings(':first').addClass('active');
    }
  }, 3000);

  /***change image on click of thumb image***/
  $(document).on(
    'click',
    `.productView-thumbnails .productView-thumbnail-link`,
    function () {
      var img_path = $(this).attr('href');
      var alt_text = $(this).find('img.productView-image--default').attr('alt');
      $('.productView-image').css('background-image', 'url(' + img_path + ')');
      $(
        '.productView-image .productView-img-container img.productView-image--default'
      ).attr('alt', alt_text);
      $(
        '.productView-image .productView-img-container img.productView-image--default'
      ).attr('title', alt_text);
    }
  );

  /***change image on click of thumb image***/
  $(window).scroll(function () {
    if ($(' .help-left-link').length) {
      /**To add class active in sidebar item**/
      var scrollPosition = $(window).scrollTop();
      $('.help-right-box, .other-support-box').each(function () {
        var current_sec = $(this);
        if (
          $(window).scrollTop() >
          current_sec.offset().top - $('.header').innerHeight() - 50
        ) {
          $('.faq-category-heading').removeClass('active');
          var active_link = current_sec.attr('id');
          $("[href='#" + active_link + "']")
            .closest('li')
            .addClass('active');
        }
      });

      /***to stick sidebar***/
      /*var top_distance = $(" .help-left").offset().top - $(".header").innerHeight(),
            bottom_distance = $(" .help-left").offset().top + $(" .help-right").height() - $(" .help-left-inner").height() - $(".header").innerHeight();
            if ($(window).scrollTop() > (top_distance - 30)) {
                if ($(window).scrollTop() > (bottom_distance + 30)) {
                    $(".help-left-inner").removeClass('fixed').addClass("absolute");
                } else {
                    $(".help-left-inner").addClass('fixed').removeClass("absolute");
                }
            } else {
                    $(" .help-left-inner").removeClass('fixed absolute');
            }*/
    }
  });

  $(window).on('load', function () {
    onlymobile();
    //fromteblet();
    megamenu_link();
  });

  //custom select

  /*--explore the layer accordian--*/
  $('.wave-technology-detail-title h3').click(function () {
    $(this).toggleClass('open');
    $('.wave-technology-detail-outer').slideToggle(400);
  });
  lineBefore();
});

$(window).on('load', function () {
  removeDisableOptionLevelStock();
  featuresBlockeqHeight();
  wave_tech_slider();
  brunel_modal();
  brunel_tab();
  dynamicFinanceRate();
  eqHeight();
});

$(window).on('resize', function (e) {
  removeDisableOptionLevelStock();
  onlymobile();
  //fromteblet();
  eqHeight();
  megamenu_link();
  brunel_modal();
  brunel_tab();
});

if ($('.registration-page').length > 0) {
  $('#FormField_31').hide();
  $('#FormField_12 .form-label').html('County <small>Required</small>');
  $('#FormField_12').attr('style', 'display:block');
}

function fromteblet() {
  if(!$('.mattress-guide-slider').length) return;

  var newWindowWidth = $(window).width();
  if (newWindowWidth < 1081) {
    $('.mattress-guide-slider').slick({
      arrows: false,
      autoplay: true,
      infinite: true,
      speed: 300,
      centerMode: true,
      centerPadding: '15%',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });
  }
}
function onlymobile() {
  if(!$('.home-promise .promise-list').length) return;

  var newWindowWidth = $(window).width();
  if (newWindowWidth < 767) {
    $('.home-promise .promise-list').slick({
      dots: true,
      infinite: true,
      arrows: false,
      centerMode: true,
      centerPadding: '25%',
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '20%',
          },
        },
      ],
    });

    $('.wave-technology-layers').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: true,
    });
  }
}

/*award-page-listing-js-start*/
function award_page_slider() {
  if(!$('.award-page-listing .promise-list').length) return;

  $('.award-page-listing .promise-list')
    .slick({
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 4,
      centerMode: true,
      centerPadding: 0,
      slidesToScroll: 1,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
    .on('afterChange', function (event, slick, currentSlide, nextSlide) {
      var dataId = $(slick.$slides[currentSlide]);
      var text = dataId.find('.promise-quote-text p').text();

      $(this)
        .closest('.award-page-listing')
        .find('.title-slider h4 p')
        .text(text);
    });
}
/*award-page-listing-js-end*/

function waveSliderSlick() {
  if(!$('.wave-slider').length) return;

  $('.wave-slider').slick({
    dots: true,
    infinite: true,
    arrows: false,
    centerMode: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

/* wave technology slider */
function wave_tech_slider() {
  if(!$('.technology-listing').length) return;

  $('.technology-listing').slick({
    dots: true,
    infinite: true,
    arrows: false,
    centerMode: true,
    centerPadding: '20%',
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          centerPadding: '10%',
        },
      },
    ],
  });
}

$(window).on('load', function () {
  award_page_slider();
  if ($(window).width() < 768) {
    waveSliderSlick();
  }
  if (navigator.appVersion.indexOf('Mac') != -1) {
    $('body , html').addClass('mac-os');
  }
  setTimeout(function () {
    var visited = jQuery.cookie('visited');
    if (visited == 'yes') {
      return false;
      eqHeight();
    } else {
      $('#check_banner').load(
        'https://brookandwildesleep.com .home-bottom-content',
        function (responseTxt, statusTxt, xhr) {
          if (statusTxt == 'success') {
            if ($(this).find('.home-bottom-content').length == 1) {
              jQuery.cookie('visited', 'yes', { expires: 1 });
            } else {
              $('.submenu-listing-wrapper .listing-block').css(
                'background-color',
                '#fff'
              );
            }
          }
        }
      );
    }
  }, 3000);

  $('#check_banner').load(
    'https://brookandwildesleep.com .home-bottom-content',
    function (responseTxt, statusTxt, xhr) {
      if (statusTxt == 'success') {
        if ($(this).find('.home-bottom-content').length == 1) {
          var counterTimePDP = '';
          var counterTime = '';
          var counterCategory1 = '';
          var counterCategory2 = '';
          var counterTimehome = '';
          var counterTimeDiv = '';
          var bannerStartDate = $('#bannerStartDate').val();
          var countDownDate = new Date(bannerStartDate).getTime();
          var x = setInterval(function () {
            var now = new Date().getTime();
            var distance = countDownDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor(
              (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            days = leftPad(days, 2);
            hours = leftPad(hours, 2);
            minutes = leftPad(minutes, 2);
            seconds = leftPad(seconds, 2);
            document.getElementById('demo').innerHTML = '';
            document.getElementById('demo').innerHTML =
              days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ';
            counterTime =
              days + 'D ' + hours + 'H ' + minutes + 'M ' + seconds + 'S ';
            counterTimePDP =
              '<span>' +
              days +
              '</span> DAYS <span>' +
              hours +
              '</span> HRS <span>' +
              minutes +
              '</span> MINS <span>' +
              seconds +
              '</span> SECS ';

            /* Category timer starts */
            counterCategory1 = '<span>ENDS IN ' + days + '</span> DAYS<span>';
            counterCategory2 =
              '<span>' +
              hours +
              '</span> HRS <span>' +
              minutes +
              '</span> MINS <span>' +
              seconds +
              '</span> SECS ';
            /* Category timer ends */

            counterTimehome =
              days +
              ' &nbsp;' +
              hours +
              ' &nbsp;' +
              minutes +
              ' &nbsp;' +
              seconds;
            counterTimeDiv =
              "<ul><li><div class='counter-time'><p>" +
              days +
              "</p></div><span>days</span></li><li><div class='counter-time'><p>" +
              hours +
              "</p></div><span>hours</span></li><li><div class='counter-time'><p>" +
              minutes +
              "</p></div><span>mins</span></li><li><div class='counter-time'><p>" +
              seconds +
              '</p></div><span>secs</span></li></ul>';

            counterTimeDiv =
              '<div class="timer-inner"><span class="timer-count">' +
              days +
              '</span><span class="timer-unit">Days</span></div><div class="timer-inner"><span class="timer-count">' +
              hours +
              '</span><span class="timer-unit">Hours</span></div><div class="timer-inner"><span class="timer-count">' +
              minutes +
              '</span><span class="timer-unit">Minutes</span></div><div class="timer-inner"><span class="timer-count">' +
              seconds +
              '</span><span class="timer-unit">Seconds</span></div>';

            // HIDE ON 14-5-2024
            $('#promo-open > div > span#home-timer-text').html(
              "<span class='end-day'>ENDS MONDAY 11/08 </span>"
            );

            $('.category-timer-text-upper').html(counterCategory1);
            $('.category-timer-text-below').html(counterCategory2);

            $('#offers #demo').html(counterTimeDiv);

            if (distance < 0) {
              clearInterval(x);
              document.getElementById('demo').innerHTML = 'EXPIRED';
            }
          }, 1000);
          $('.all-promo-popup').attr('style', '');
          if ($('#promo-open').css('opacity') == 0) {
            $('.cookieMessage').removeClass('cookie-open');
          } else {
            $('.cookieMessage').addClass('cookie-open');
          }

          $('#promo-open > div > span#promoData').html(
            $('.home-bottom-content .promo-text').prop('outerHTML')
          );
          $('#promo-open > div > span#promoData2').html(
            $('.home-bottom-content .promo-text2').prop('outerHTML')
          );
          $('#promo-open > div > span#content-text').html(
            $('.home-bottom-content .promo-text3').prop('outerHTML')
          );

          $('#offers .discount-rate').html(
            $('.home-bottom-content .section-title1').prop('outerHTML')
          );
          $('#offers .discount-product').html(
            $('.home-bottom-content .section-subtitle1').prop('outerHTML')
          );
          $('#offers .limited-text').html(
            $('.home-bottom-content .section-content1').prop('outerHTML')
          );
          $('#offers .or-promo').html(
            $('.home-bottom-content .or').prop('outerHTML')
          );
          $('#offers .discount-rate2').html(
            $('.home-bottom-content .section-title2').prop('outerHTML')
          );
          $('#offers .discount-product2').html(
            $('.home-bottom-content .section-subtitle2').prop('outerHTML')
          );
          $('#offers .limited-text2').html(
            $('.home-bottom-content .section-content2').prop('outerHTML')
          );
          $('#offers .timer-block-wrap p').html(
            $('.home-bottom-content .test-content').prop('outerHTML')
          );
          $('#offers .exclude-content').html(
            $('.home-bottom-content .exclude-content').prop('outerHTML')
          );
          $('#offers .section-content-link').html(
            $('.home-bottom-content .section-content-2 a').prop('outerHTML')
          );
        } else {
          // $('.modal-promo').hide();
          // $('#offers').hide();
          // $('.cookieMessage').removeClass('cookie-open');
        }
      }
      if (statusTxt == 'error') {
        console.log('Error: ' + xhr.status + ': ' + xhr.statusText);
      }
    },
    1000
  );

  $('#check_banner').load(
    'https://brookandwildesleep.com .home-bottom-content',
    function (responseTxt, statusTxt, xhr) {
      if (statusTxt == 'success') {
        if ($(this).find('.home-bottom-content').length == 1) {
          $('.all-promo-popup').attr('style', '');
          if ($('#promo-open').css('opacity') == 0) {
            $('.cookieMessage').removeClass('cookie-open');
          } else {
            $('.cookieMessage').addClass('cookie-open');
          }

          $('#promo-open > div > span#promoData').html(
            $('.home-bottom-content .promo-text').prop('outerHTML')
          );
          $('#promo-open > div > span#promoData2').html(
            $('.home-bottom-content .promo-text2').prop('outerHTML')
          );
          $('#promo-open > div > span#content-text').html(
            $('.home-bottom-content .promo-text3').prop('outerHTML')
          );

          $('#offers .section-title').html(
            $('.home-bottom-content .section-title1').prop('outerHTML')
          );
          $('#offers .section-subtitle').html(
            $('.home-bottom-content .section-subtitle1').prop('outerHTML')
          );
          $('#offers .section-content').html(
            $('.home-bottom-content .section-content1').prop('outerHTML')
          );
          $('#offers .test-content').html(
            $('.home-bottom-content .test-content').prop('outerHTML')
          );
          $('#offers .exclude-content').html(
            $('.home-bottom-content .exclude-content').prop('outerHTML')
          );
          $('#offers .section-content-link').html(
            $('.home-bottom-content .section-content-2 a').prop('outerHTML')
          );
        } else {
          // $('.modal-promo').hide();
          // $('#offers').hide();
          // $('.cookieMessage').removeClass('cookie-open');
        }
      }
      if (statusTxt == 'error') {
        console.log('Error: ' + xhr.status + ': ' + xhr.statusText);
      }
    }
  );
});

function leftPad(number, targetLength) {
  var output = number + '';
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return output;
}

// for line before
function lineBefore() {
  var top_pos = 47;
  var left_pos = 50;
  var this_top = top_pos;
  var this_left = left_pos;

  $('.line-text-wrapper em').each(function () {
    $(this).css('top', this_top + 'px');
    $(this)
      .css('left', '-100%')
      .css('left', '+=' + this_left + 'px');
    this_top = this_top + 25;
    this_left = this_left + 30;
  });
}

$(window).resize(function (e) {
  if ($('.award-page-listing .promise-list').length > 0) {
    $('.award-page-listing .promise-list')[0].slick.refresh();
  }
  if ($('.technology-listing').length > 0) {
    $('.technology-listing')[0].slick.refresh();
  }
  award_page_slider();
  wave_tech_slider();

  if ($(window).width() > 767) {
  } else {
    waveSliderSlick();
  }
});

$('.navPages').find('.price-description').hide();
$('.piglet-listing').find('.menu-description').hide();

/*for header js-start*/
$(window).scroll(function () {
  if ($(window).scrollTop() > 0) {
    $('.header .listing-block').css('background-color', '#fff');
  }
});
